var _jsxFileName = "/Users/kayote/Documents/ReactApps/fretboard-viz-tool/dependencies/react-fretboard/components/Fretboard/index.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../../../../fretboard-viz-tool/node_modules/react'
import pt from 'prop-types'
import { mergeDeepRight } from 'ramda'
import { ThemeProvider } from 'styled-components'
import defaultTheme from './../../themes/fretboard-theme.js'

import { locShape, noteSelectionShape, locSelectionShape } from './../../lib/shapes'
import { ensureNoteObjects, ensureLocObjects } from './../../lib/fretboard'


import Neck from './Neck'
import PositionLabels from './PositionLabels'

import Wrapper from './Wrapper'

/**
 * **This is the main api component**
 *
 * Here the props get split up in roughly two categories:
 * - props and theme props that determine the dimensions and overall look of the fretboard. They are passed directly to the children
 * - props that determine the appearance of the individual frets, ie the content and color of a Fret. They are passed through react context, and get picked up several levels down by the Fret component.
 */

class Fretboard extends React.Component {
  getChildContext() {
    return {
      skinType: this.props.skinType,
      noteType: this.props.noteType,
      showNotes: this.props.showNotes,
      showSelectionLabels: this.props.showSelectionLabels,
      highlightOctaves: this.props.highlightOctaves,
      highlightSelections: this.props.highlightSelections,
      showEnharmonics: this.props.showEnharmonics,
      selectedNotes: ensureNoteObjects(this.props.selectedNotes),
      selectedLocations: ensureLocObjects(this.props.selectedLocations),
      clickAction: this.props.clickAction,
      clickOffAction: this.props.clickOffAction,
      touchMoveAction: this.props.touchMoveAction,
      selectedStrings: this.props.selectedStrings,
      fretHighlight: pt.arrayOf(pt.number).isRequired,
      fretHighlightColor: pt.string
    }
  }
  render() {
    const {
      tuning,
      nrOfFrets,
      skinType,
      showPositionLabels,
      theme,
      selectedStrings,
      fretHighlight,
      fretHighlightColor
    } = this.props;
    const mergedTheme = mergeDeepRight(defaultTheme, theme);
    const {
      dimensions
    } = mergedTheme;
    const {
      openWidth,
      nutWidth
    } = dimensions;
    return /*#__PURE__*/React.createElement(ThemeProvider, {
      theme: mergedTheme,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 54,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(Wrapper, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 55,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(Neck, _extends({
      tuning,
      nrOfFrets,
      skinType,
      dimensions,
      selectedStrings,
      fretHighlight,
      fretHighlightColor
    }, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 56,
        columnNumber: 11
      }
    })), showPositionLabels && /*#__PURE__*/React.createElement(PositionLabels, _extends({
      nrOfFrets,
      nutWidth,
      openWidth
    }, {
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 65,
        columnNumber: 13
      }
    }))));
  }


}

Fretboard.propTypes = {
  tuning: pt.arrayOf(pt.string),
  nrOfFrets: pt.number,
  skinType: pt.oneOf(['boxes', 'strings']),
  noteType: pt.oneOf(['pc', 'pitch']),
  showNotes: pt.bool,
  showSelectionLabels: pt.bool,
  highlightOctaves: pt.bool,
  highlightSelections: pt.bool,
  showEnharmonics: pt.bool,
  showPositionLabels: pt.bool,
  selectedNotes: pt.arrayOf(pt.oneOfType([pt.string, noteSelectionShape])),
  selectedLocations: pt.arrayOf(pt.oneOfType([locShape, locSelectionShape])),
  theme: pt.shape({}),
  clickAction: pt.func,
  clickOffAction: pt.func,
  touchMoveAction: pt.func,
  selectedStrings: pt.arrayOf(pt.string),
  fretHighlight: pt.arrayOf(pt.number),
  fretHighlightColor: pt.string
}

Fretboard.defaultProps = {
  tuning: ['E2', 'A2', 'D3', 'G3', 'B3', 'E4'],
  nrOfFrets: 12,
  skinType: 'boxes',
  noteType: 'pitch',
  showNotes: false,
  showSelectionLabels: true,
  highlightOctaves: false,
  highlightSelections: true,
  showEnharmonics: false,
  showPositionLabels: true,
  selectedNotes: [],
  selectedLocations: [],
  theme: {},
  clickAction: undefined,
  clickOffAction: undefined,
  touchMoveAction: undefined,
  selectedStrings: [],
  fretHighlight: [],
  fretHighlightColor: 'none'
}

Fretboard.childContextTypes = {
  skinType: pt.string,
  noteType: pt.string,
  showNotes: pt.bool,
  showSelectionLabels: pt.bool,
  highlightOctaves: pt.bool,
  highlightSelections: pt.bool,
  showEnharmonics: pt.bool,
  selectedNotes: pt.arrayOf(noteSelectionShape),
  selectedLocations: pt.arrayOf(locSelectionShape),
  clickAction: pt.func,
  clickOffAction: pt.func,
  touchMoveAction: pt.func,
  selectedStrings: pt.arrayOf(pt.string),
  fretHighlight: pt.arrayOf(pt.number),
  fretHighlightColor: pt.string
}

export default Fretboard
